import { c as _c } from "react/compiler-runtime";
import { useCallback } from "react";
import { LocalStorageUtils } from "@utils/local-storage-utils";

/** Type definition for the return value of the useCredentials hook */

/**
 * Custom hook that provides credential actions for the dev features dialog.
 */
export function useCredentials() {
  const $ = _c(1);
  const saveAnalyticsCredentials = _temp;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      saveAnalyticsCredentials
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(username, password) {
  if (username) {
    LocalStorageUtils.setStringItem("analytics-api-username", username);
  } else {
    LocalStorageUtils.removeItem("analytics-api-username");
  }
  if (password) {
    LocalStorageUtils.setStringItem("analytics-api-password", password);
  } else {
    LocalStorageUtils.removeItem("analytics-api-password");
  }
  window.location.reload();
}